var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cta",style:([{ 'border-color': _vm.myColors.main }]),on:{"click":_vm.goToDestination}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }